import { useEffect, useState } from 'react';
import { debug } from 'zf-web-infra';
import type { DataSource, TreeKeys } from '../types';
import type { TreeService } from '../service';
import type { SearchData } from './types';

export function useSearch(service: TreeService, data: DataSource, defaultExpandedKeys: TreeKeys): SearchData {
  debug.common('useSearch');

  const [expandedKeys, setExpandedKeys] = useState<TreeKeys>([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  /**
   * useState(defaultExpandedKeys) 只会初始化一次
   * defaultExpandedKeys 是异步获取的所以 expandedKeys 一直为空数组
   */
  useEffect(() => {
    setExpandedKeys(defaultExpandedKeys);
  }, [defaultExpandedKeys]);

  /**
   * 支持检索树节点
   * @param value
   */
  const onSearch = (value: string): void => {
    debug.common('onSearch', value);

    const isSearching = value.trim().length > 0;
    setAutoExpandParent(isSearching);

    const keys = isSearching ? service.findExpandedByText(data, value) : [];
    setExpandedKeys(keys.length > 0 ? keys : defaultExpandedKeys);
  };

  /**
   * 维持，并更新展开状态
   * @param keys
   */
  const onExpand = (keys: TreeKeys): void => {
    debug.common('onExpand', keys);
    setExpandedKeys(keys);
    setAutoExpandParent(false);
  };

  return { onExpand, onSearch, expandedKeys, autoExpandParent };
}
